import React from "react";
import {
  Activity,
  LineChart,
  Sparkles,
  ShieldCheck,
  Brain,
  Clock,
} from "lucide-react";

const ITEMS = [
  {
    icon: Activity,
    title: "Günlük Piyasa Takibi",
    desc: "BIST endeksleri, sektör hareketleri ve önemli haber akışı düzenli olarak izlenir; piyasanın yönüne dair güncel bilgilendirmeler hazırlanır.",
    span: "md:col-span-2",
  },
  {
    icon: LineChart,
    title: "Teknik & Temel Analiz",
    desc: "Grafik formasyonları, momentum göstergeleri ve şirket bilançolarının birlikte değerlendirildiği çok katmanlı analiz yaklaşımı.",
    span: "md:col-span-1",
  },
  {
    icon: Sparkles,
    title: "Fırsat Hisse Değerlendirmeleri",
    desc: "Kısa ve orta vadede potansiyel sunabilecek hisseler için bağımsız bakış açısı.",
    span: "md:col-span-1",
  },
  {
    icon: ShieldCheck,
    title: "Risk Yönetimi",
    desc: "Portföy çeşitlendirmesi, zarar kesme noktaları ve pozisyon büyüklüğü gibi temel risk başlıkları üzerine bilgilendirme.",
    span: "md:col-span-2",
  },
  {
    icon: Brain,
    title: "Piyasa Psikolojisi",
    desc: "Yatırımcı davranışları, duygusal kararları minimize etme stratejileri ve disiplinli yatırım için zihinsel hazırlık.",
    span: "md:col-span-2",
  },
  {
    icon: Clock,
    title: "Kısa & Uzun Vade Bakışı",
    desc: "Farklı vade beklentilerine göre yapılandırılmış strateji ve portföy değerlendirmeleri.",
    span: "md:col-span-1",
  },
];

export default function MarketInfo() {
  return (
    <section
      id="borsa-bilgilendirmeleri"
      className="relative py-24 md:py-32 bg-[#070e26] border-y border-white/5"
      data-testid="market-info-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <span
            className="section-eyebrow"
            data-testid="market-info-eyebrow"
          >
            Borsa Bilgilendirmeleri
          </span>
          <h2
            className="font-serif text-white text-[clamp(2rem,4.6vw,3.75rem)] leading-[1.08] mt-3"
            data-testid="market-info-title"
          >
            Piyasayı yakından,
            <br />
            <span className="italic text-gold-gradient">disiplinle takip et.</span>
          </h2>
          <p className="mt-6 text-[#cbd5e1] text-base md:text-lg font-light leading-relaxed">
            Aşağıdaki başlıklar, paylaşımlarda öne çıkan temel konuları
            özetler. Tüm içerikler genel bilgilendirme amaçlıdır.
          </p>
        </div>

        <div
          className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5"
          data-testid="market-info-grid"
        >
          {ITEMS.map(({ icon: Icon, title, desc, span }, idx) => (
            <article
              key={title}
              className={`glass-card rounded-2xl p-7 md:p-8 group relative overflow-hidden ${span}`}
              data-testid={`market-info-card-${idx}`}
            >
              <div className="flex items-start gap-5">
                <span className="shrink-0 w-12 h-12 rounded-full border border-[#d4af37]/40 flex items-center justify-center bg-[#d4af37]/5 group-hover:bg-[#d4af37]/15 transition-colors duration-500">
                  <Icon size={20} className="text-[#d4af37]" />
                </span>
                <div className="flex-1">
                  <h3 className="font-serif text-white text-2xl md:text-[26px] leading-tight">
                    {title}
                  </h3>
                  <p className="mt-3 text-[#94a3b8] text-[15px] font-light leading-relaxed">
                    {desc}
                  </p>
                </div>
              </div>
              {/* Gold corner accent on hover */}
              <span className="absolute top-0 right-0 w-12 h-12 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <span className="absolute top-3 right-3 w-3 h-3 border-t border-r border-[#d4af37]" />
              </span>
              <span className="absolute bottom-0 right-0 font-serif text-[100px] leading-none text-[#d4af37]/[0.04] select-none">
                {String(idx + 1).padStart(2, "0")}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
